import { Element } from 'react-scroll/modules';
import Checkboxes from '../form/base/Checkboxes';
import classNames from 'classnames';
import Collapse, { Panel } from 'rc-collapse';
import HourWidget from '../form/complex/HourWidget';
import Radio from '../form/base/Radio';
import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import RequiredSpan from '../form/base/RequiredSpan';
import TextArea from '../form/base/TextArea';
import TextField from '../form/base/TextField';
import { AppContext } from '../../context/AppContext';
import { Field, FormikConsumer } from 'formik';

class VisitorTab extends Component {
  static contextType = AppContext;

  render() {
    const requiredHeader = (header) => {
      return (
        <span>{header} <RequiredSpan /></span>
      )
    };

    return (
      <FormikConsumer>
        {({ isSubmitting, errors, touched, setFieldValue }) => (
          <div>
            <h2>Plan Your Visit</h2>
            <div className="misc-elements">
              <Radio label="Appointment Required?"
                name="appointment_required"
                options={[
                  { label: 'Yes', value: '1' },
                  { label: 'No', value: '0' }
                ]} />
              <TextArea label="Eligibility" name="eligibility" />
              <HourWidget />
              <TextField label="Hours (Additional Notes)" name="hours_comment" />
            </div>

            <Collapse accordion={false} defaultActiveKey={['0', '1', '2', '3']}>
              <Panel header={requiredHeader('Fee Information')}>
                <Checkboxes name="fees"
                  hasError={touched['fees'] && errors['fees']}
                  options={this.props.formData.fee_information} />
              </Panel>
            </Collapse>
            <div className={classNames(
              'submit',
              'recaptcha-wrapper',
            )}>
              <Element name="token">
                <Field type="hidden" name="token" />
                <ReCAPTCHA
                  size="normal"
                  sitekey={this.props.formData.recaptcha_site_key}
                  onChange={async (token) => {
                    setFieldValue('token', token);
                  }}
                  onErrored={() => {
                    setFieldValue('token', '');
                  }}
                  onExpired={() => {
                    setFieldValue('token', '');
                  }} />
              </Element>
              <button
                className='usa-button'
                type="submit"
                disabled={isSubmitting}>Submit</button>
            </div>
          </div>
        )}
      </FormikConsumer>
    )
  }
}

export default VisitorTab;
